import React from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  Divider,
  CircularProgress,
} from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

const ConfirmDeleteModal = ({
  open,
  onClose,
  onConfirm,
  message,
  loading = false,
}) => {
  return (
    <Modal
      open={open}
      onClose={!loading ? onClose : undefined}
      disableEnforceFocus
      disableAutoFocus
      sx={{ zIndex: 40000 }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 500,
          bgcolor: "#fff",
          boxShadow: 24,
          borderRadius: 3,
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            background: "var(--thm-color)",
            padding: "15px",
            borderRadius: "10px 10px 0px 0px",
            marginBottom: "15px",
          }}
        >
          <WarningAmberRoundedIcon
            sx={{ fontSize: 32, color: "#e0ddddff" }}
          />
          <Typography
            variant="h6"
            sx={{ fontWeight: 700, color: "#e0ddddff" }}
          >
            Confirm Deletion
          </Typography>
        </Box>

        {/* Message */}
        <Typography
          sx={{
            color: "text.secondary",
            lineHeight: 1.6,
            padding: "8px 20px",
          }}
        >
          {message ||
            "Are you sure you want to delete this item? This action cannot be undone."}
        </Typography>

        <Divider sx={{ my: 2 }} />

        {/* Buttons */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            mt: 3,
            padding: "0px 15px 15px",
          }}
        >
          <Button
            color="error"
            variant="contained"
            onClick={onConfirm}
            disabled={loading}
            className="btn btn-colored"
          >
            {loading ? (
              <>
                <CircularProgress
                  size={18}
                  color="inherit"
                  sx={{ mr: 1 }}
                />
                Deleting...
              </>
            ) : (
              "Delete"
            )}
          </Button>

          <Button
            variant="outlined"
            onClick={onClose}
            disabled={loading}
            className="btn btn-border"
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmDeleteModal;
